(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_2e03e4a"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeVisualSearchBanners = (root = document) => {
      root.querySelectorAll('[data-visual-search-trigger]').forEach((button) => {
        if (button.dataset.visualSearchReady === 'true') return;
        button.dataset.visualSearchReady = 'true';

        button.addEventListener('click', () => {
          const banner = button.closest('.visual-search-banner');
          const status = banner?.querySelector('[data-visual-search-status]');
          const uploadButton = document.querySelector('birse-img-upload-button.birse-img-upload-btn, .birse-img-upload-btn');

          if (!uploadButton) {
            if (status) status.textContent = button.dataset.unavailableMessage || '';
            return;
          }

          if (status) status.textContent = '';
          const uploadInput = uploadButton.querySelector('input[type="file"]');

          if (uploadInput) {
            uploadInput.click();
          } else {
            uploadButton.click();
          }
        });
      });
    };

    initializeVisualSearchBanners();
    document.addEventListener('shopify:section:load', (event) => initializeVisualSearchBanners(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    class ReadMoreText extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      const textBlock = this.querySelector('.text-block.read-more');
      const toggle = this.querySelector('.read-more-toggle');
      if (!textBlock || !toggle) return;

      const lines = Number(this.dataset.lines) || 2;
      const readMoreLabel = this.dataset.readMoreLabel || 'Lexo më shumë';
      const readLessLabel = this.dataset.readLessLabel || 'Lexo më pak';

      const getLineHeight = (element) => {
        const target = element.querySelector('p, li, h1, h2, h3, h4, h5, h6, span') || element;
        const styles = getComputedStyle(target);
        const lineHeight = parseFloat(styles.lineHeight);

        if (!Number.isNaN(lineHeight) && lineHeight > 0) {
          return lineHeight;
        }

        const probe = document.createElement('span');
        probe.textContent = 'A';
        probe.style.visibility = 'hidden';
        probe.style.position = 'absolute';
        target.appendChild(probe);
        const measured = probe.getBoundingClientRect().height;
        probe.remove();
        return measured || 16;
      };

      const collapse = () => {
        const lineHeight = getLineHeight(textBlock);
        const maxHeight = lineHeight * lines;

        textBlock.classList.add('is-collapsed');
        textBlock.classList.remove('is-expanded');
        textBlock.style.maxHeight = `${maxHeight}px`;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = readMoreLabel;
      };

      const expand = () => {
        textBlock.classList.remove('is-collapsed');
        textBlock.classList.add('is-expanded');
        textBlock.style.maxHeight = '';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = readLessLabel;
      };

      const setup = () => {
        textBlock.classList.remove('is-collapsed', 'is-expanded');
        textBlock.style.maxHeight = '';

        const lineHeight = getLineHeight(textBlock);
        const maxHeight = lineHeight * lines;

        if (textBlock.scrollHeight <= maxHeight + 1) {
          toggle.hidden = true;
          return;
        }

        toggle.hidden = false;

        if (toggle.getAttribute('aria-expanded') === 'true') {
          expand();
        } else {
          collapse();
        }
      };

      setup();

      toggle.addEventListener('click', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') {
          collapse();
        } else {
          expand();
        }
      });

      window.addEventListener('resize', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') return;
        setup();
      });
    }
  }

  if (!customElements.get('read-more-text')) {
    customElements.define('read-more-text', ReadMoreText);
  }
  } catch(e) { console.error(e); }
})();

})();
